import * as React from "react"
import { ReactComponent as arrowLeft } from "media/svg/arrowLeft.svg"
import "./IconButton.scss"
import { Color } from "types/bootstrap"

interface IconButton {
	color: Color
	src?: any | React.ComponentType<React.SVGProps<SVGSVGElement>>
	right?: boolean
}

const IconButton: React.FC<
	IconButton & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({
	children,
	src = arrowLeft,
	right = false,
	color,
	className,
	...rest
}) => {
	const Component = src
	return (
		<button
			className={`icon-button btn btn-${color} ${className}`}
			{...rest}
		>
			{right && <Component className="icon-button__image ml-2" />}
			{children}
			{right || <Component className="icon-button__image mr-2" />}
		</button>
	)
}

export default IconButton
